import AdminList from '../views/administrators/adminList';
import AdminLog from '../views/administrators/adminLog';

import Main from '../views/main';

const Administrators = {
  path: '/admin-list',
  component: Main,
  title: '管理员管理',
  icon: 'el-icon-s-custom',
  meta: { keepAlive: false },
  children: [
    {
      path: '/admin-list',
      component: AdminList,
      name: 'adminList',
      title: '管理员列表',
      meta: { title: '管理员列表' ,keepAlive: false }
    },
    {
      path: '/admin-log',
      component: AdminLog,
      name: 'adminLog',
      title: '操作日志',
      meta: { title: '管理员操作日志' ,keepAlive: false }
    }
  ]
};
export default Administrators;
